import { getLowestPriceForItemModifier, isInheritedItemPrice, isZeroMonetaryValue } from '@vista/omnichannel-components-domain';
export const getFormattedPriceForModifier = (baseItem, modifier, discountedPriceFormat, i18n) => {
    const lowestPrice = getLowestPriceForItemModifier(baseItem, modifier);
    const isInheritedPrice = isInheritedItemPrice(lowestPrice);
    if (!isInheritedPrice && isZeroMonetaryValue(lowestPrice.price))
        return;
    const formattedPrice = i18n.monetaryValue(lowestPrice.price);
    return isInheritedPrice ? i18n.template(discountedPriceFormat, { price: formattedPrice }) : formattedPrice;
};
